import { validEmailRegex, validEmailRegex2 } from './regexs'

export const isValidEmail = (email: string) => {
    const emailIsFilled = email?.trim()?.length
    const emailIsValid =
        email?.match(validEmailRegex) && email?.match(validEmailRegex2)
    return emailIsFilled && emailIsValid ? true : false
}
